<template>
  <div id="selectoption">
    <div class="thead">Покупка ROBUX</div>
    <div class="sub">Выберите способ покупки</div>
    <div class="section all-center">
      <div class="label">По gamepass</div>
      <div class="buttons">
        <button class="fs20" @click="buyOne">Купить один раз</button>
        <button class="fs20" @click="buyMany">Купить много</button>
      </div>
    </div>
    <div class="section all-center">
      <div class="label">По группе</div>
      <div class="buttons">
        <button class="fs20" @click="buyGroup">Купить</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SelectOption",

  methods: {
    buyOne() {
      this.$root.setState({ label: "buy-one" });
    },

    buyMany() {
      this.$root.setState({ label: "buy-many" });
    },

    buyGroup() {
      this.$root.setState({ label: "buy-group" });
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/assets/mixins.scss";
#selectoption {
  max-width: 1022px;
  min-width: 800px; 

  //@include mobile {
  //  min-width: auto;
  //}

  > .section { 
    text-align: left;
    min-width: 800px;
    //@include mobile {
    //  min-width: auto;
    //}
    > .label {
      padding: 25px;
      font-size: 24px;
    }
    > .buttons {
      gap: 25px;
      display: flex;
      //@include mobile {
      //  flex-wrap: wrap;
      //}
      //> * {
        //@include mobile {
        //  padding: 16px 32px 16px 32px;
        //  width: 100%;
        //}
      //}
    }
  }
}
</style>
